import { isPublicFolderComposeViewState } from './createPublicFolderComposeViewState';
import closeCompose from '../actions/closeCompose';
import trySaveMessage from '../actions/trySaveMessage';
import trySendMessage from '../actions/trySendMessage';
import { ComposeViewState } from 'owa-mail-compose-store';
import setSendDisabled from 'owa-mail-compose-actions/lib/actions/setSendDisabled';

export default function handleOnSend(viewState: ComposeViewState): Promise<Error | void> {
    let sendSavePromise;
    if (isPublicFolderComposeViewState(viewState)) {
        sendSavePromise = trySaveMessage(viewState).catch(error => error);
        closeCompose(viewState);
    } else {
        setSendDisabled(viewState, true);
        sendSavePromise = trySendMessage(viewState).catch(error => {
            // Re-enable the Send button when send fails, so user can try sending again
            // This includes the case where Send has been canceled by the user (i.e. undo send)
            setSendDisabled(viewState, false);
            return error;
        });
    }
    return sendSavePromise;
}
